import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/activity/')({
  component: ActivityManagement,
})

// TODO: Chưa implement - Trang tổng quan hoạt động (redirect hoặc dashboard activity)
function ActivityManagement() {
  return <div>Hello "/_authenticated/activity/"!</div>
}
